var _g, _g2, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMobile1(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 91,
    viewBox: "0 0 80 91",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_3401_4591)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2.67676 19.9371C2.67676 12.7921 8.4689 7 15.6139 7H53.7396C60.8846 7 66.6768 12.7921 66.6768 19.9371V58.0629C66.6768 65.2079 60.8846 71 53.7396 71H15.6139C8.4689 71 2.67676 65.2079 2.67676 58.0629V19.9371Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.6139 7.40428H53.7396C60.6613 7.40428 66.2725 13.0154 66.2725 19.9371V58.0629C66.2725 64.9846 60.6613 70.5957 53.7396 70.5957H15.6139C8.69218 70.5957 3.08104 64.9846 3.08104 58.0629V19.9371C3.08104 13.0154 8.69218 7.40428 15.6139 7.40428Z",
    stroke: "#B4C4E4",
    strokeOpacity: 0.423529,
    strokeWidth: 0.808569
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3401_4591)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M43.6772 38.1775V39.0055C43.6761 40.9464 43.0476 42.8349 41.8855 44.3894C40.7235 45.9439 39.09 47.0811 37.2288 47.6314C35.3676 48.1817 33.3783 48.1156 31.5578 47.443C29.7372 46.7703 28.1828 45.5272 27.1264 43.8991C26.0701 42.2709 25.5683 40.3448 25.696 38.4082C25.8237 36.4715 26.574 34.628 27.8351 33.1526C29.0961 31.6773 30.8002 30.649 32.6934 30.2213C34.5865 29.7936 36.5672 29.9893 38.34 30.7792",
    stroke: "#243251",
    strokeWidth: 1.80007,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.6775 31.8066L34.6772 40.816L31.9771 38.1159",
    stroke: "#243251",
    strokeWidth: 1.80007,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_3401_4591",
    x: -10.2604,
    y: 0.531445,
    width: 89.8742,
    height: 89.8742,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 6.46856
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 6.46856
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.615686 0 0 0 0 0.686275 0 0 0 0 0.776471 0 0 0 0.2 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_3401_4591"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_3401_4591",
    result: "shape"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3401_4591"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white",
    transform: "translate(24.677 29)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMobile1);
export default __webpack_public_path__ + "static/media/Mobile1.0501295d3e96b64291fd7c9094f58c03.svg";
export { ForwardRef as ReactComponent };